import { IStrapiDocument } from 'src/app/interfaces/strapi';
import { ICarousel } from 'src/app/interfaces/strapi/carousel.interface';
import { City } from './city.model';
import { PolicyDocument } from './policy.model';

export class University {
  uuid!: string | null;

  name!: string;

  cmsId!: string | null;

  searchableName!: string;

  city!: City | null;

  isSearchable!: boolean;

  is_pathway_provider!: boolean;

  pathway_provider_title!: string | null;

  pathway_provider_logo!: string | null;

  pathway_provider_policy_number!: string | null;

  policyDocuments!: PolicyDocument[] | null;

  pathway_provider_disclaimer!: string | null;

  pathway_provider_overview!: string | null;

  is_unihome_product!: boolean | null;

  show_partner?: boolean | null;

  partner_link_uid?: string | null;

  registration_unihomes_carousel!: IStrapiDocument<ICarousel | null>;
}
